import React from 'react';

import { flagStyles } from '../settings';

const SvgBM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-600px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBM;
